import React, {useRef, useState, useEffect} from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { uploadAudio } from 'features/audio/audioSlice'
import { setSelectedAudioSource, setSelectedAudioFile, resetAudioUploadSuccess, setViewUploadAudioModal } from 'features/audio/audioSlice'
import SourceSelect from '../SourceSelect'
import { IoArrowBack } from "react-icons/io5";
import { GoBackButton, FileUploadInput, ButttonWrap, FormWrap } from 'components/files/files.styled' 
import SpinnerSmall from 'components/SpinnerSmall'
import { toast } from 'react-hot-toast'
import { StyledTextInput, StyledHeading, UploadModalContainer, InputNameWrap, InputNameWrapChild, SelectFileBtn, StyledSubmitButton } from 'components/media/media.styled';
import { PiFileAudio } from "react-icons/pi";
import { useTranslation } from 'react-i18next'



export default function UploadAudioModal() {
    const { t } = useTranslation('media')

    const dispatch = useDispatch() 
    const audioRef = useRef(null)
    const audioTitleRef = useRef(null)
    const urlRef = useRef(null)
    const audioDescriptionRef = useRef(null)
    const { selectedAudioSource, selectedAudioFile, audioUploading, audioUploadSuccess } = useSelector((state) => state.audio)
    const { profileChurch } = useSelector((state) => state.profileChurch)

    const handleUploadAudio = () => {


        if(selectedAudioSource === 'url' && !urlRef.current.value){
            return toast.error(t('validation.enterUrl'))
        }
        if(selectedAudioSource === 'device' && !audioRef.current.files[0]){
            return toast.error(t('validation.selectFile'))
        }
        if(!audioTitleRef.current.value){
            return toast.error(t('validation.enterTitle'))
        }
        if(!audioDescriptionRef.current.value){
            return toast.error(t('validation.addDescription'))
        }

        let formData = new FormData()
 
        formData.append('churchId', profileChurch._id)
        if(selectedAudioSource === 'device'){
            formData.append('file', audioRef.current.files[0])
        } 
        formData.append('title', audioTitleRef.current.value)
        formData.append('description', audioDescriptionRef.current.value)
        formData.append('originSource', selectedAudioSource === 'device' ? 'device' : 'url')

        if(selectedAudioSource === 'url'){
            formData.append('audioUrl', urlRef.current.value)
        }

        dispatch(uploadAudio(formData))

    }

    const handleAudioFileChange = (e) => {
        dispatch(setSelectedAudioFile(e.target.files[0]))

        // edit the input ref to shorten the file name

        // audioRef.current.value = e.target.files[0].name.slice(0, 10) + (e.target.files[0].name.length > 10 ? '...' : '')

    }

    useEffect(() => { 
        if(audioUploadSuccess){ 
            dispatch(setSelectedAudioFile(null))
            dispatch(setSelectedAudioSource(null))
            dispatch(resetAudioUploadSuccess())
            dispatch(setViewUploadAudioModal(false))
        }
    }, [ audioUploadSuccess ])


    if(!selectedAudioSource){
        return (
            <SourceSelect
                handler1={() => dispatch(setSelectedAudioSource('device'))}
                handler2={() => dispatch(setSelectedAudioSource('url'))}
                mediaType={'audio'}
                />
        )
    }

    return (
        <UploadModalContainer> 

                <StyledHeading>
                    <PiFileAudio size={24} /> 
                    <span>{t('audioUpload')}</span>
                </StyledHeading>

                <GoBackButton onClick={() => dispatch(setSelectedAudioSource(null))}> <IoArrowBack /> <span>{t('goBack')}</span> </GoBackButton>
                
                <FormWrap>
                    <InputWrap> 
                        <StyledTextInput 
                            placeholder={t('audioFileTitle')}
                            ref={audioTitleRef}
                            /> 
                        {
                            selectedAudioSource === 'url' ? 
                            ( 
                                <StyledTextInput 
                                    placeholder={t('audioUrl')}
                                    ref={urlRef}
                                    />
                            )
                            : selectedAudioSource === 'device' &&
                            (
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                                    <InputNameWrap style={{ marginRight: '10px'}}> 
                                        <InputNameWrapChild style={{ width: "160px"}}> 
                                            {selectedAudioFile ? 
                                                (
                                                    selectedAudioFile.name.slice(0, 18) + (selectedAudioFile.name.length > 18 ? '...' : '' )
                                                ) 
                                                :  
                                                (<i style={{fontSize: "13px"}}>{t('noFileSelected')}</i>)
                                            }
                                        </InputNameWrapChild>
                                        <FileUploadInput  
                                            hidden id="audioUpload"  
                                            ref={audioRef}
                                            type="file"   
                                            accept='audio/*'
                                            name="file"  
                                            onChange={handleAudioFileChange}
                                            />                     
                                                                    
                                        <SelectFileBtn htmlFor="audioUpload"> 
                                            <PiFileAudio />
                                            <span>{t('selectAudio')}</span>
                                        </SelectFileBtn>        
                                    </InputNameWrap>                       

                                </div> 
                            )
                        }    

    
                        <DescTextArea 
                            placeholder={t('descriptionOptional')}
                            ref={audioDescriptionRef}
                            />                
                    </InputWrap>

                    <ButttonWrap>
                        <StyledSubmitButton 
                            disabled={audioUploading}
                            canSubmit={ !audioUploading }
                            onClick={handleUploadAudio}
                            >
                                {
                                    audioUploading ? (
                                        <SpinnerSmall />
                                    )
                                    :
                                    (
                                        <> 
                                            <span>{t('upload')}</span>
                                        </>
                                    )
                                } 
                        </StyledSubmitButton>
                    </ButttonWrap>
                </FormWrap> 
        </UploadModalContainer>
    )
}


 
const DescTextArea = styled.textarea`
    padding: 10px;
    width: 100%;
    height: 100px;
    border: 3px solid transparent; 
    border-radius: 15px;
    outline: none;
    font-size: 16px;
    color: var(--lightThemeFontColor); 
    resize: none;
    font-family: Arial, Helvetica, sans-serif;
    background-color: aliceblue;

    &:focus{
        border: 3px solid #51CBEE;
    }

    &::placeholder{
        color: var(--lightThemeFontColor);
        opacity: 0.7;
        font-size: 14px;
    }

`

const InputWrap = styled.div`
    width: 100%;
    display: flex;  
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
`
